import { Box } from "@chakra-ui/react";
import { Tag } from "src/components/common/tag/tag";
import { IFeedCardTagBody } from "src/components/feed-card/types/content";

export const FeedCardTag = ({ text, tooltip, color, isCrossedOut }: IFeedCardTagBody) => {
    const adjustedTooltipWithLink = tooltip?.link ? { ...tooltip, link: { ...tooltip.link, target: "_blank" } } : undefined;
    return (
        <Box>
            <Tag label={text} color={color} tooltip={adjustedTooltipWithLink} isCrossedOut={isCrossedOut} />
        </Box>
    );
};
